/*  tanstack  */
import { CellContext } from '@tanstack/react-table';

/*  Reports  */
import { runReportLinkURL } from 'application/Home/Reports/helpers';

/*  Shared  */
import { calculateScheduledReportTimeRange } from 'application/Shared/Helpers/scheduledReportsDeliveryTime';
import { ScheduledReport as ScheduledReportType } from 'application/Shared/types/scheduledReport';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

export const ReportNameClickableCell = ({
    row
}: CellContext<ScheduledReportType, unknown>): React.ReactElement => {
    const { t } = useTranslation();
    const { partnerId, clientId } = useParams();

    // Based on the scheduled report period, we need to run this for the current day/week/month/quarter/customQuarter
    // therefore, we need to overwrite the start and end dates.
    const { startTime, endTime } = calculateScheduledReportTimeRange({
        dateCreated: row.original.dateCreated,
        period: row.original.params.period
    });

    const to = runReportLinkURL({
        clientId,
        partnerId,
        reportParams: { ...row.original.params, endTime, startTime }
    });

    return (
        <Link
            to={to}
            key={row.original.id}
            data-testid="reportNameClickableCell_routeTo"
            data-trackid="reportNameClickableCell_routeTo"
            className="link underline"
        >
            {t(row.original.name)}
        </Link>
    );
};
